import React, { useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";

import Button, { ButtonTypes } from "../../../../components/Button";
import { Field, FieldLabel } from "../../../../components/FormPanel";
import { FormTextArea } from "../../../../components/Input";
import { ActionError, RejectActions, RejectForm } from "../styles";
import { RejectRequestFormProps, RejectRequestValues } from "../types";

const MAX_REASON_LENGTH = 500;

export const RejectRequestForm: React.FC<RejectRequestFormProps> = ({
  initialReason,
  isSubmitting,
  error,
  onReasonChange,
  onReject,
  onCancel,
}) => {
  const { control, handleSubmit } = useForm<RejectRequestValues>({
    defaultValues: { reason: initialReason },
  });
  const typedReason = useWatch({ control, name: "reason" });
  const reason = typedReason.trim();
  const isReasonValid = reason.length > 0 && reason.length <= MAX_REASON_LENGTH;

  useEffect(() => onReasonChange(typedReason), [typedReason, onReasonChange]);

  return (
    <RejectForm
      noValidate
      onSubmit={handleSubmit((values) => onReject(values.reason.trim()))}
    >
      <Field>
        <FieldLabel htmlFor="ticker-request-reject-reason">
          Reason sent to requesters
        </FieldLabel>
        <FormTextArea
          id="ticker-request-reject-reason"
          name="reason"
          control={control}
          maxLength={MAX_REASON_LENGTH}
          showCharacterCount
          disabled={isSubmitting}
        />
      </Field>
      {error && <ActionError role="alert">{error}</ActionError>}
      <RejectActions>
        <Button
          type={ButtonTypes.danger}
          buttonType="submit"
          disabled={!isReasonValid}
          isLoading={isSubmitting}
        >
          Reject request
        </Button>
        <Button
          type={ButtonTypes.cancel}
          disabled={isSubmitting}
          onClick={onCancel}
        >
          Keep reviewing
        </Button>
      </RejectActions>
    </RejectForm>
  );
};
